<template>
  <Select @on-change="changeData" filterable transfer v-model="iconValue">
    <i :class="iconValue" slot="prefix"></i>
    <OptionGroup label="阿里图标">
      <Option :key="icon.key" :label="icon.key" :value="icon.key" v-for="icon in iconListAli">
        <div class="options">
          <i :class="icon.key"></i>
          <span class="ml1">{{ icon.value}}</span>
        </div>
      </Option>
    </OptionGroup>
    <OptionGroup label="图片图标库（不可改色）">
      <Option :key="icon.key" :label="icon.key" :value="icon.key" v-for="icon in iconListImg">
        <div class="options">
          <i :class="icon.key"></i>
          <span class="ml1">{{ icon.value}}</span>
        </div>
      </Option>
    </OptionGroup>
    <OptionGroup label="字体图标库">
      <Option :key="icon.key" :label="icon.key" :value="icon.key" v-for="icon in iconList">
        <div class="options">
          <i :class="icon.key"></i>
          <span class="ml1">{{ icon.value}}</span>
        </div>
      </Option>
    </OptionGroup>
  </Select>
</template>
<script>
export default {
  name: 'iconSelect',
  props: {
    value: ''
  },
  data () {
    return {
      iconList: [{
        key: "fa fa-adjust",
        value: "fa-adjust"
      }, {
        key: "fa fa-anchor",
        value: "fa-anchor"
      }, {
        key: "fa fa-archive",
        value: "fa-archive"
      }, {
        key: "fa fa-arrows",
        value: "fa-arrows"
      }, {
        key: "fa fa-arrows-h",
        value: "fa-arrows-h"
      }, {
        key: "fa fa-arrows-v",
        value: "fa-arrows-v"
      }, {
        key: "fa fa-asterisk",
        value: "fa-asterisk"
      }, {
        key: "fa fa-automobile",
        value: "fa-automobil"
      }, {
        key: "fa fa-ban",
        value: "fa-ban"
      }, {
        key: "fa fa-bank",
        value: "fa-bank"
      }, {
        key: "fa fa-bar-chart-o",
        value: "fa-bar-chart-o"
      }, {
        key: "fa fa-barcode",
        value: "fa-barcode"
      }, {
        key: "fa fa-bars",
        value: "fa-bars"
      }, {
        key: "fa fa-beer",
        value: "fa-beer"
      }, {
        key: "fa fa-bell",
        value: "fa-bell"
      }, {
        key: "fa fa-bell-o",
        value: "fa-bell-o"
      }, {
        key: "fa fa-bolt",
        value: "fa-bolt"
      }, {
        key: "fa fa-bomb",
        value: "fa-bomb"
      }, {
        key: "fa fa-book",
        value: "fa-book"
      }, {
        key: "fa fa-bookmark",
        value: "fa-bookmark"
      }, {
        key: "fa fa-bookmark-o",
        value: "fa-bookmark-o"
      }, {
        key: "fa fa-briefcase",
        value: "fa-briefcase"
      }, {
        key: "fa fa-bug",
        value: "fa-bug"
      }, {
        key: "fa fa-building",
        value: "fa-building"
      }, {
        key: "fa fa-building-o",
        value: "fa-building-o"
      }, {
        key: "fa fa-bullhorn",
        value: "fa-bullhorn"
      }, {
        key: "fa fa-bullseye",
        value: "fa-bullseye"
      }, {
        key: "fa fa-cab",
        value: "fa-cab"
      }, {
        key: "fa fa-calendar",
        value: "fa-calendar"
      }, {
        key: "fa fa-calendar-o",
        value: "fa-calendar-o"
      }, {
        key: "fa fa-camera",
        value: "fa-camera"
      }, {
        key: "fa fa-camera-retro",
        value: "fa-camera-retro"
      }, {
        key: "fa fa-car",
        value: "fa-car"
      }, {
        key: "fa fa-caret-square-o-down",
        value: "fa-caret-square-o-down"
      }, {
        key: "fa fa-caret-square-o-left",
        value: "fa-caret-square-o-left"
      }, {
        key: "fa fa-caret-square-o-right",
        value: "fa-caret-square-o-right"
      }, {
        key: "fa fa-caret-square-o-up",
        value: "fa-caret-square-o-up"
      }, {
        key: "fa fa-certificate",
        value: "fa-certificate"
      }, {
        key: "fa fa-check",
        value: "fa-check"
      }, {
        key: "fa fa-check-circle",
        value: "fa-check-circle"
      }, {
        key: "fa fa-check-circle-o",
        value: "fa-check-circle-o"
      }, {
        key: "fa fa-check-square",
        value: "fa-check-square"
      }, {
        key: "fa fa-check-square-o",
        value: "fa-check-square-o"
      }, {
        key: "fa fa-child",
        value: "fa-child"
      }, {
        key: "fa fa-circle",
        value: "fa-circle"
      }, {
        key: "fa fa-circle-o",
        value: "fa-circle-o"
      }, {
        key: "fa fa-circle-o-notch",
        value: "fa-circle-o-notch"
      }, {
        key: "fa fa-circle-thin",
        value: "fa-circle-thin"
      }, {
        key: "fa fa-clock-o",
        value: "fa-clock-o"
      }, {
        key: "fa fa-cloud",
        value: "fa-cloud"
      }, {
        key: "fa fa-cloud-download",
        value: "fa-cloud-download"
      }, {
        key: "fa fa-cloud-upload",
        value: "fa-cloud-upload"
      }, {
        key: "fa fa-code",
        value: "fa-code"
      }, {
        key: "fa fa-code-fork",
        value: "fa-code-fork"
      }, {
        key: "fa fa-coffee",
        value: "fa-coffee"
      }, {
        key: "fa fa-cog",
        value: "fa-cog"
      }, {
        key: "fa fa-cogs",
        value: "fa-cogs"
      }, {
        key: "fa fa-comment",
        value: "fa-comment"
      }, {
        key: "fa fa-comment-o",
        value: "fa-comment-o"
      }, {
        key: "fa fa-comments",
        value: "fa-comments"
      }, {
        key: "fa fa-comments-o",
        value: "fa-comments-o"
      }, {
        key: "fa fa-compass",
        value: "fa-compass"
      }, {
        key: "fa fa-credit-card",
        value: "fa-credit-card"
      }, {
        key: "fa fa-crop",
        value: "fa-crop"
      }, {
        key: "fa fa-crosshairs",
        value: "fa-crosshairs"
      }, {
        key: "fa fa-cube",
        value: "fa-cube"
      }, {
        key: "fa fa-cubes",
        value: "fa-cubes"
      }, {
        key: "fa fa-cutlery",
        value: "fa-cutlery"
      }, {
        key: "fa fa-dashboard",
        value: "fa-dashboard"
      }, {
        key: "fa fa-database",
        value: "fa-database"
      }, {
        key: "fa fa-desktop",
        value: "fa-desktop"
      }, {
        key: "fa fa-dot-circle-o",
        value: "fa-dot-circle-o"
      }, {
        key: "fa fa-download",
        value: "fa-download"
      }, {
        key: "fa fa-edit",
        value: "fa-edit"
      }, {
        key: "fa fa-ellipsis-h",
        value: "fa-ellipsis-h"
      }, {
        key: "fa fa-ellipsis-v",
        value: "fa-ellipsis-v"
      }, {
        key: "fa fa-envelope",
        value: "fa-envelope"
      }, {
        key: "fa fa-envelope-o",
        value: "fa-envelope-o"
      }, {
        key: "fa fa-envelope-square",
        value: "fa-envelope-square"
      }, {
        key: "fa fa-eraser",
        value: "fa-eraser"
      }, {
        key: "fa fa-exchange",
        value: "fa-exchange"
      }, {
        key: "fa fa-exclamation",
        value: "fa-exclamation"
      }, {
        key: "fa fa-exclamation-circle",
        value: "fa-exclamation-circle"
      }, {
        key: "fa fa-exclamation-triangle",
        value: "fa-exclamation-triangle"
      }, {
        key: "fa fa-external-link",
        value: "fa-external-link"
      }, {
        key: "fa fa-external-link-square",
        value: "fa-external-link-square"
      }, {
        key: "fa fa-eye",
        value: "fa-eye"
      }, {
        key: "fa fa-eye-slash",
        value: "fa-eye-slash"
      }, {
        key: "fa fa-fax",
        value: "fa-fax"
      }, {
        key: "fa fa-female",
        value: "fa-female"
      }, {
        key: "fa fa-fighter-jet",
        value: "fa-fighter-jet"
      }, {
        key: "fa fa-file-archive-o",
        value: "fa-file-archive-o"
      }, {
        key: "fa fa-file-audio-o",
        value: "fa-file-audio-o"
      }, {
        key: "fa fa-file-code-o",
        value: "fa-file-code-o"
      }, {
        key: "fa fa-file-excel-o",
        value: "fa-file-excel-o"
      }, {
        key: "fa fa-file-image-o",
        value: "fa-file-image-o"
      }, {
        key: "fa fa-file-movie-o",
        value: "fa-file-movie-o"
      }, {
        key: "fa fa-file-pdf-o",
        value: "fa-file-pdf-o"
      }, {
        key: "fa fa-file-photo-o",
        value: "fa-file-photo-o"
      }, {
        key: "fa fa-file-picture-o",
        value: "fa-file-picture-o"
      }, {
        key: "fa fa-file-powerpoint-o",
        value: "fa-file-powerpoint-o"
      }, {
        key: "fa fa-file-sound-o",
        value: "fa-file-sound-o"
      }, {
        key: "fa fa-file-video-o",
        value: "fa-file-video-o"
      }, {
        key: "fa fa-file-word-o",
        value: "fa-file-word-o"
      }, {
        key: "fa fa-file-zip-o",
        value: "fa-file-zip-o"
      }, {
        key: "fa fa-film",
        value: "fa-film"
      }, {
        key: "fa fa-filter",
        value: "fa-filter"
      }, {
        key: "fa fa-fire",
        value: "fa-fire"
      }, {
        key: "fa fa-fire-extinguisher",
        value: "fa-fire-extinguisher"
      }, {
        key: "fa fa-flag",
        value: "fa-flag"
      }, {
        key: "fa fa-flag-checkered",
        value: "fa-flag-checkered"
      }, {
        key: "fa fa-flag-o",
        value: "fa-flag-o"
      }, {
        key: "fa fa-flash",
        value: "fa-flash"
      }, {
        key: "fa fa-flask",
        value: "fa-flask"
      }, {
        key: "fa fa-folder",
        value: "fa-folder"
      }, {
        key: "fa fa-folder-o",
        value: "fa-folder-o"
      }, {
        key: "fa fa-folder-open",
        value: "fa-folder-open"
      }, {
        key: "fa fa-folder-open-o",
        value: "fa-folder-open-o"
      }, {
        key: "fa fa-frown-o",
        value: "fa-frown-o"
      }, {
        key: "fa fa-gamepad",
        value: "fa-gamepad"
      }, {
        key: "fa fa-gavel",
        value: "fa-gavel"
      }, {
        key: "fa fa-gear",
        value: "fa-gear"
      }, {
        key: "fa fa-gears",
        value: "fa-gears"
      }, {
        key: "fa fa-gift",
        value: "fa-gift"
      }, {
        key: "fa fa-glass",
        value: "fa-glass"
      }, {
        key: "fa fa-globe",
        value: "fa-globe"
      }, {
        key: "fa fa-graduation-cap",
        value: "fa-graduation-cap"
      }, {
        key: "fa fa-group",
        value: "fa-group"
      }, {
        key: "fa fa-hdd-o",
        value: "fa-hdd-o"
      }, {
        key: "fa fa-headphones",
        value: "fa-headphones"
      }, {
        key: "fa fa-heart",
        value: "fa-heart"
      }, {
        key: "fa fa-heart-o",
        value: "fa-heart-o"
      }, {
        key: "fa fa-history",
        value: "fa-history"
      }, {
        key: "fa fa-home",
        value: "fa-home"
      }, {
        key: "fa fa-image",
        value: "fa-imag"
      }, {
        key: "fa fa-inbox",
        value: "fa-inbox"
      }, {
        key: "fa fa-info",
        value: "fa-info"
      }, {
        key: "fa fa-info-circle",
        value: "fa-info-circle"
      }, {
        key: "fa fa-institution",
        value: "fa-institution"
      }, {
        key: "fa fa-key",
        value: "fa-key"
      }, {
        key: "fa fa-keyboard-o",
        value: "fa-keyboard-o"
      }, {
        key: "fa fa-language",
        value: "fa-language"
      }, {
        key: "fa fa-laptop",
        value: "fa-laptop"
      }, {
        key: "fa fa-leaf",
        value: "fa-leaf"
      }, {
        key: "fa fa-legal",
        value: "fa-legal"
      }, {
        key: "fa fa-lemon-o",
        value: "fa-lemon-o"
      }, {
        key: "fa fa-level-down",
        value: "fa-level-down"
      }, {
        key: "fa fa-level-up",
        value: "fa-level-up"
      }, {
        key: "fa fa-life-bouy",
        value: "fa-life-bouy"
      }, {
        key: "fa fa-life-ring",
        value: "fa-life-ring"
      }, {
        key: "fa fa-life-saver",
        value: "fa-life-saver"
      }, {
        key: "fa fa-lightbulb-o",
        value: "fa-lightbulb-o"
      }, {
        key: "fa fa-location-arrow",
        value: "fa-location-arrow"
      }, {
        key: "fa fa-lock",
        value: "fa-lock"
      }, {
        key: "fa fa-magic",
        value: "fa-magic"
      }, {
        key: "fa fa-magnet",
        value: "fa-magnet"
      }, {
        key: "fa fa-mail-forward",
        value: "fa-mail-forward"
      }, {
        key: "fa fa-mail-reply",
        value: "fa-mail-reply"
      }, {
        key: "fa fa-mail-reply-all",
        value: "fa-mail-reply-all"
      }, {
        key: "fa fa-male",
        value: "fa-male"
      }, {
        key: "fa fa-map-marker",
        value: "fa-map-marker"
      }, {
        key: "fa fa-meh-o",
        value: "fa-meh-o"
      }, {
        key: "fa fa-microphone",
        value: "fa-microphone"
      }, {
        key: "fa fa-microphone-slash",
        value: "fa-microphone-slash"
      }, {
        key: "fa fa-minus",
        value: "fa-minus"
      }, {
        key: "fa fa-minus-circle",
        value: "fa-minus-circle"
      }, {
        key: "fa fa-minus-square",
        value: "fa-minus-square"
      }, {
        key: "fa fa-minus-square-o",
        value: "fa-minus-square-o"
      }, {
        key: "fa fa-mobile",
        value: "fa-mobile"
      }, {
        key: "fa fa-mobile-phone",
        value: "fa-mobile-phon"
      }, {
        key: "fa fa-money",
        value: "fa-money"
      }, {
        key: "fa fa-moon-o",
        value: "fa-moon-o"
      }, {
        key: "fa fa-mortar-board",
        value: "fa-mortar-board"
      }, {
        key: "fa fa-music",
        value: "fa-music"
      }, {
        key: "fa fa-navicon",
        value: "fa-navicon"
      }, {
        key: "fa fa-paper-plane",
        value: "fa-paper-plane"
      }, {
        key: "fa fa-paper-plane-o",
        value: "fa-paper-plane-o"
      }, {
        key: "fa fa-paw",
        value: "fa-paw"
      }, {
        key: "fa fa-pencil",
        value: "fa-pencil"
      }, {
        key: "fa fa-pencil-square",
        value: "fa-pencil-square"
      }, {
        key: "fa fa-pencil-square-o",
        value: "fa-pencil-square-o"
      }, {
        key: "fa fa-phone",
        value: "fa-phone"
      }, {
        key: "fa fa-phone-square",
        value: "fa-phone-square"
      }, {
        key: "fa fa-photo",
        value: "fa-photo"
      }, {
        key: "fa fa-picture-o",
        value: "fa-picture-o"
      }, {
        key: "fa fa-plane",
        value: "fa-plane"
      }, {
        key: "fa fa-plus",
        value: "fa-plus"
      }, {
        key: "fa fa-plus-circle",
        value: "fa-plus-circle"
      }, {
        key: "fa fa-plus-square",
        value: "fa-plus-square"
      }, {
        key: "fa fa-plus-square-o",
        value: "fa-plus-square-o"
      }, {
        key: "fa fa-power-off",
        value: "fa-power-off"
      }, {
        key: "fa fa-print",
        value: "fa-print"
      }, {
        key: "fa fa-puzzle-piece",
        value: "fa-puzzle-piece"
      }, {
        key: "fa fa-qrcode",
        value: "fa-qrcode"
      }, {
        key: "fa fa-question",
        value: "fa-question"
      }, {
        key: "fa fa-question-circle",
        value: "fa-question-circle"
      }, {
        key: "fa fa-quote-left",
        value: "fa-quote-left"
      }, {
        key: "fa fa-quote-right",
        value: "fa-quote-right"
      }, {
        key: "fa fa-random",
        value: "fa-random"
      }, {
        key: "fa fa-recycle",
        value: "fa-recycle"
      }, {
        key: "fa fa-refresh",
        value: "fa-refresh"
      }, {
        key: "fa fa-reorder",
        value: "fa-reorder"
      }, {
        key: "fa fa-reply",
        value: "fa-reply"
      }, {
        key: "fa fa-reply-all",
        value: "fa-reply-all"
      }, {
        key: "fa fa-retweet",
        value: "fa-retweet"
      }, {
        key: "fa fa-road",
        value: "fa-road"
      }, {
        key: "fa fa-rocket",
        value: "fa-rocket"
      }, {
        key: "fa fa-rss",
        value: "fa-rss"
      }, {
        key: "fa fa-rss-square",
        value: "fa-rss-square"
      }, {
        key: "fa fa-search",
        value: "fa-search"
      }, {
        key: "fa fa-search-minus",
        value: "fa-search-minus"
      }, {
        key: "fa fa-search-plus",
        value: "fa-search-plus"
      }, {
        key: "fa fa-send",
        value: "fa-send"
      }, {
        key: "fa fa-send-o",
        value: "fa-send-o"
      }, {
        key: "fa fa-share",
        value: "fa-share"
      }, {
        key: "fa fa-share-alt",
        value: "fa-share-alt"
      }, {
        key: "fa fa-share-alt-square",
        value: "fa-share-alt-square"
      }, {
        key: "fa fa-share-square",
        value: "fa-share-square"
      }, {
        key: "fa fa-share-square-o",
        value: "fa-share-square-o"
      }, {
        key: "fa fa-shield",
        value: "fa-shield"
      }, {
        key: "fa fa-shopping-cart",
        value: "fa-shopping-cart"
      }, {
        key: "fa fa-sign-in",
        value: "fa-sign-in"
      }, {
        key: "fa fa-sign-out",
        value: "fa-sign-out"
      }, {
        key: "fa fa-signal",
        value: "fa-signal"
      }, {
        key: "fa fa-sitemap",
        value: "fa-sitemap"
      }, {
        key: "fa fa-sliders",
        value: "fa-sliders"
      }, {
        key: "fa fa-smile-o",
        value: "fa-smile-o"
      }, {
        key: "fa fa-sort",
        value: "fa-sort"
      }, {
        key: "fa fa-sort-alpha-asc",
        value: "fa-sort-alpha-asc"
      }, {
        key: "fa fa-sort-alpha-desc",
        value: "fa-sort-alpha-desc"
      }, {
        key: "fa fa-sort-amount-asc",
        value: "fa-sort-amount-asc"
      }, {
        key: "fa fa-sort-amount-desc",
        value: "fa-sort-amount-desc"
      }, {
        key: "fa fa-sort-asc",
        value: "fa-sort-asc"
      }, {
        key: "fa fa-sort-desc",
        value: "fa-sort-desc"
      }, {
        key: "fa fa-sort-down",
        value: "fa-sort-down"
      }, {
        key: "fa fa-sort-numeric-asc",
        value: "fa-sort-numeric-asc"
      }, {
        key: "fa fa-sort-numeric-desc",
        value: "fa-sort-numeric-desc"
      }, {
        key: "fa fa-sort-up",
        value: "fa-sort-up"
      }, {
        key: "fa fa-space-shuttle",
        value: "fa-space-shuttle"
      }, {
        key: "fa fa-spinner",
        value: "fa-spinner"
      }, {
        key: "fa fa-spoon",
        value: "fa-spoon"
      }, {
        key: "fa fa-square",
        value: "fa-square"
      }, {
        key: "fa fa-square-o",
        value: "fa-square-o"
      }, {
        key: "fa fa-star",
        value: "fa-star"
      }, {
        key: "fa fa-star-half",
        value: "fa-star-half"
      }, {
        key: "fa fa-star-half-empty",
        value: "fa-star-half-empty"
      }, {
        key: "fa fa-star-half-full",
        value: "fa-star-half-full"
      }, {
        key: "fa fa-star-half-o",
        value: "fa-star-half-o"
      }, {
        key: "fa fa-star-o",
        value: "fa-star-o"
      }, {
        key: "fa fa-suitcase",
        value: "fa-suitcase"
      }, {
        key: "fa fa-sun-o",
        value: "fa-sun-o"
      }, {
        key: "fa fa-support",
        value: "fa-support"
      }, {
        key: "fa fa-tablet",
        value: "fa-tablet"
      }, {
        key: "fa fa-tachometer",
        value: "fa-tachometer"
      }, {
        key: "fa fa-tag",
        value: "fa-tag"
      }, {
        key: "fa fa-tags",
        value: "fa-tags"
      }, {
        key: "fa fa-tasks",
        value: "fa-tasks"
      }, {
        key: "fa fa-taxi",
        value: "fa-taxi"
      }, {
        key: "fa fa-terminal",
        value: "fa-terminal"
      }, {
        key: "fa fa-thumb-tack",
        value: "fa-thumb-tack"
      }, {
        key: "fa fa-thumbs-down",
        value: "fa-thumbs-down"
      }, {
        key: "fa fa-thumbs-o-down",
        value: "fa-thumbs-o-down"
      }, {
        key: "fa fa-thumbs-o-up",
        value: "fa-thumbs-o-up"
      }, {
        key: "fa fa-thumbs-up",
        value: "fa-thumbs-up"
      }, {
        key: "fa fa-ticket",
        value: "fa-ticket"
      }, {
        key: "fa fa-times",
        value: "fa-times"
      }, {
        key: "fa fa-times-circle",
        value: "fa-times-circle"
      }, {
        key: "fa fa-times-circle-o",
        value: "fa-times-circle-o"
      }, {
        key: "fa fa-tint",
        value: "fa-tint"
      }, {
        key: "fa fa-toggle-down",
        value: "fa-toggle-down"
      }, {
        key: "fa fa-toggle-left",
        value: "fa-toggle-left"
      }, {
        key: "fa fa-toggle-right",
        value: "fa-toggle-right"
      }, {
        key: "fa fa-toggle-up",
        value: "fa-toggle-up"
      }, {
        key: "fa fa-trash-o",
        value: "fa-trash-o"
      }, {
        key: "fa fa-tree",
        value: "fa-tree"
      }, {
        key: "fa fa-trophy",
        value: "fa-trophy"
      }, {
        key: "fa fa-truck",
        value: "fa-truck"
      }, {
        key: "fa fa-umbrella",
        value: "fa-umbrella"
      }, {
        key: "fa fa-university",
        value: "fa-university"
      }, {
        key: "fa fa-unlock",
        value: "fa-unlock"
      }, {
        key: "fa fa-unlock-alt",
        value: "fa-unlock-alt"
      }, {
        key: "fa fa-unsorted",
        value: "fa-unsorted"
      }, {
        key: "fa fa-upload",
        value: "fa-upload"
      }, {
        key: "fa fa-user",
        value: "fa-user"
      }, {
        key: "fa fa-users",
        value: "fa-users"
      }, {
        key: "fa fa-video-camera",
        value: "fa-video-camera"
      }, {
        key: "fa fa-volume-down",
        value: "fa-volume-down"
      }, {
        key: "fa fa-volume-off",
        value: "fa-volume-off"
      }, {
        key: "fa fa-volume-up",
        value: "fa-volume-up"
      }, {
        key: "fa fa-warning",
        value: "fa-warning"
      }, {
        key: "fa fa-wheelchair",
        value: "fa-wheelchair"
      }, {
        key: "fa fa-wrench",
        value: "fa-wrench"
      }],
      iconListImg: [],
      iconListAli: [
        {
          key: "iconfont icon-albums",
          value: "icon-albums"
        },
        {
          key: "iconfont icon-arrowDown",
          value: "icon-arrowDown"
        }, {
          key: "iconfont icon-arrowUp",
          value: "icon-arrowUp"
        }, {
          key: "iconfont icon-arrowLeft",
          value: "icon-arrowLeft"
        }, {
          key: "iconfont icon-calendar",
          value: "icon-calendar"
        }, {
          key: "iconfont icon-add",
          value: "icon-add"
        }, {
          key: "iconfont icon-edit",
          value: "icon-edit"
        }, {
          key: "iconfont icon-clean",
          value: "icon-clean"
        }, {
          key: "iconfont icon-delete",
          value: "icon-delete"
        }, {
          key: "iconfont icon-appendix",
          value: "icon-appendix"
        }, {
          key: "iconfont icon-Excel",
          value: "icon-Excel"
        }, {
          key: "iconfont icon-doc",
          value: "icon-doc"
        }, {
          key: "iconfont icon-exit",
          value: "icon-exit"
        }, {
          key: "iconfont icon-call",
          value: "icon-call"
        }, {
          key: "iconfont icon-download",
          value: "icon-download"
        }, {
          key: "iconfont icon-info",
          value: "icon-info"
        }, {
          key: "iconfont icon-heart",
          value: "icon-heart"
        }, {
          key: "iconfont icon-gov",
          value: "icon-gov"
        }, {
          key: "iconfont icon-book",
          value: "icon-book"
        }, {
          key: "iconfont icon-law2",
          value: "icon-law2"
        }, {
          key: "iconfont icon-champion",
          value: "icon-champion"
        },
        {
          key: "iconfont icon-false",
          value: "icon-false"
        }, {
          key: "iconfont icon-location",
          value: "icon-location"
        }, {
          key: "iconfont icon-in",
          value: "icon-in"
        }, {
          key: "iconfont icon-history",
          value: "icon-history"
        },

        {
          key: "iconfont icon-pie",
          value: "icon-pie"
        },
        {
          key: "iconfont icon-plus",
          value: "icon-plus"
        },
        {
          key: "iconfont icon-search",
          value: "icon-search"
        },
        {
          key: "iconfont icon-pic",
          value: "icon-pic"
        },

        {
          key: "iconfont icon-password",
          value: "icon-password"
        }, {
          key: "iconfont icon-check",
          value: "icon-check"
        }, {
          key: "iconfont icon-upload",
          value: "icon-upload"
        },

        {
          key: "iconfont icon-video",
          value: "icon-video"
        },
        {
          key: "iconfont icon-message",
          value: "icon-message"
        },
        {
          key: "iconfont icon-record",
          value: "icon-record"
        }, {
          key: "iconfont icon-warn",
          value: "icon-warn"
        }, {
          key: "iconfont icon-lawyer",
          value: "icon-lawyer"
        }, {
          key: "iconfont icon-refresh",
          value: "icon-refresh"
        }, {
          key: "iconfont icon-rules",
          value: "icon-rules"
        }, {
          key: "iconfont icon-star",
          value: "icon-star"
        },
        {
          key: "iconfont icon-sidemenu",
          value: "icon-sidemenu"
        },
        {
          key: "iconfont icon-minus",
          value: "icon-minus"
        },
        {
          key: "iconfont icon-pdf",
          value: "icon-pdf"
        },


        {
          key: "iconfont icon-user",
          value: "icon-user"
        }, {
          key: "iconfont icon-statistics",
          value: "icon-statistics"
        }, {
          key: "iconfont icon-logout",
          value: "icon-logout"
        }, {
          key: "iconfont icon-see",
          value: "icon-see"
        },

        {
          key: "iconfont icon-share",
          value: "icon-share"
        },
        {
          key: "iconfont icon-true",
          value: "icon-true"
        },
        {
          key: "iconfont icon-word",
          value: "icon-word"
        },

        {
          key: "iconfont icon-ques",
          value: "icon-ques"
        },

        {
          key: "iconfont icon-set",
          value: "icon-set"
        }, {
          key: "iconfont icon-userlist",
          value: "icon-userlist"
        },
        {
          key: "iconfont icon-Txt",
          value: "icon-Txt"
        },
        {
          key: "iconfont icon-more",
          value: "icon-more"
        },

        {
          key: "iconfont icon-taizhang",
          value: "icon-taizhang"
        }, {
          key: "iconfont icon-add1",
          value: "icon-add1"
        }, {
          key: "iconfont icon-home1",
          value: "icon-home1"
        }, {
          key: "iconfont icon-law11",
          value: "icon-law11"
        }, {
          key: "iconfont icon-save1",
          value: "icon-save1"
        }, {
          key: "iconfont icon-heartEmpty",
          value: "icon-heartEmpty"
        },

        {
          key: "iconfont icon-statisticsEmpty",
          value: "icon-statisticsEmpty"
        }, {
          key: "iconfont icon-pieEmpty",
          value: "icon-pieEmpty"
        }, {
          key: "iconfont icon-unsee1",
          value: "icon-unsee1"
        },

        {
          key: "iconfont icon-checkEmpty",
          value: "icon-checkEmpty"
        }, {
          key: "iconfont icon-home2",
          value: "icon-home2"
        }, {
          key: "iconfont icon-bookEmpty",
          value: "icon-bookEmpty"
        }, {
          key: "iconfont icon-add2",
          value: "icon-add2"
        }, {
          key: "iconfont icon-save2",
          value: "icon-save2"
        }
      ],
      visible: false,
      iconValue: ''
    }
  },
  watch: {
    value: {
      handler (newValue, oldValue) {
        this.iconValue = newValue
      }
    }
  },
  methods: {
    getIcons: function () {
      let requireComponent = require.context(
        '@/assets/static/extendIcons/icons', // 在当前目录下查找
        false, // 不遍历子文件夹
        /\.png$/ // 正则匹配 以 .vue结尾的文件
      )
      requireComponent.keys().forEach(fileName => {
        let names = fileName.split('.')
        if (names.length > 1) {
          let name = names[1].replace('/', '')
          this.iconListImg.push({
            key: `exIcon exIcon-${name}`,
            value: `exIcon-${name}`
          })
          // 误删 用于生成css
          // console.log(`.exIcon-${name}::after { background-image: url(./icons/${name}.png);}`)
        }
      })

    },
    changeData: function (data) {
      console.log('changeData', data)
      this.iconValue = data
      this.visible = false
      this.$emit('change', data)
    },
    clear: function () {
      this.close()
      this.iconValue = ''
      this.$emit('change', '')
    },
  },
  beforeMount () {
    this.getIcons()
  },
}
</script>

<style lang="less" scoped>
.options {
  display: flex;
  align-items: baseline;
  justify-content: flex-start;

  .fa {
    width: 1rem;
    text-align: center;
  }
}
</style>